import * as ApiNames from '../../constants/ApiNames';
import * as SkuTypes from '../../constants/SkuTypes';
/**
 * This map indicates breakpoints when we want to change copy for a sku.
 * Format: api-name-[highestLegacyVersionNumber]
 */

export const ProductBillingNameVersions = {
  [ApiNames.SALES_HUB_STARTER]: [4],
  [ApiNames.SALES_HUB_PROFESSIONAL]: [7],
  [ApiNames.SALES_HUB_ENTERPRISE]: [3],
  [ApiNames.SERVICE_HUB_STARTER]: [3],
  [ApiNames.SERVICE_HUB_PROFESSIONAL]: [2],
  [ApiNames.SERVICE_HUB_ENTERPRISE]: [3]
};

/**
 * Gets the billingNameKey for a sku (either a ProductVersion or quantityPack)
 * If the sku passed is a ProductVersion, apiName is required
 */
const getProductBillingNameKey = ({
  apiName,
  sku,
  productBillingNameVersions = ProductBillingNameVersions
}) => {
  if (!sku) return null;

  switch (sku.skuType) {
    case SkuTypes.PRODUCT_VERSION:
      {
        if (apiName) {
          let versionToUse;
          const versionsList = productBillingNameVersions[apiName];

          if (versionsList) {
            versionToUse = versionsList.sort().reverse().find(versionSearch => versionSearch <= sku.versionNumber);
          }

          return versionToUse ? `${apiName}-${versionToUse}` : apiName;
        }

        console.error('Must pass apiName to get the billingNameKey of a ProductVersion');
        return null;
      }

    case SkuTypes.QUANTITY_PACK:
      {
        return sku.parcelName;
      }

    default:
      return null;
  }
};

export default getProductBillingNameKey;